import React from 'react'
//import {uid} from '../utils.js'
//import EditCtrl from '../cmp/EditCtrl.js';
import icon from '../icons.svg'

function CatTablesEdit({data,size,actions}){
    let wndData={}
    if(data) wndData={...data}
    //const setWndData=actions.setWndData

    const currSize=size||1

    const setValue=(data)=>{
        wndData.name=data
        wndData.edit=true
        actions(wndData)
    }

    const setActive=()=>{
        let active=true
        if (wndData.active) active=false
        const newData={...wndData,active}
        actions(newData)
    }

    let posX = 0, posY = 0

    function dragMouseDown(e) {
      e = e || window.event;
      posX = parseInt(e.clientX/currSize)*currSize
      posY = parseInt(e.clientY/currSize)*currSize
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        let pos1 = 0, pos2 = 0, pos3 =0, pos4 = 0
        e = e || window.event
        // calculate the new cursor position:
        pos3 = parseInt(e.clientX/currSize)*currSize
        pos4 = parseInt(e.clientY/currSize)*currSize
        pos1 = posX - pos3
        pos2 = posY - pos4
        posX = pos3
        posY = pos4
        if(wndData.top-pos2<0) return
        if(wndData.left-pos1<0) return
        // set the element's new position:
        if (pos2!==0) wndData.top=parseInt(wndData.top)-pos2    
        if (pos1!==0) wndData.left=parseInt(wndData.left)-pos1
        if (pos2!==0 || pos1!==0) {wndData.edit=true;actions(wndData)}
      }
    
    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null
        document.onmousemove = null
        document.ontouchend = null
        document.ontouchcancel = null
        document.ontouchmove = null
    }

    function resizeMouseDown(e,x=1,y=1) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        posX = parseInt(e.clientX/currSize)*currSize
        posY = parseInt(e.clientY/currSize)*currSize
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = (e)=>elementResize(e,x,y)
    }

    function elementResize(e,x,y) {
        let pos1 = 0, pos2 = 0, pos3 =0, pos4 = 0
        e = e || window.event;
        // calculate the new cursor position:
        pos3 = parseInt(e.clientX/currSize)*currSize
        pos4 = parseInt(e.clientY/currSize)*currSize
        pos1 = posX - pos3
        pos2 = posY - pos4
        if (x===0) pos1=0
        if (y===0) pos2=0
        posX = pos3
        posY = pos4
        if(parseInt(wndData.width) - pos1*x<20) return
        if(parseInt(wndData.height) - pos2*y<20) return
        // set the element's new position:
        if (pos1!==0) wndData.width = parseInt(wndData.width) - pos1*x
        if (pos2!==0) wndData.height = parseInt(wndData.height) - pos2*y
        if (pos1!==0&&x===-1) wndData.left = parseInt(wndData.left) - pos1
        if (pos2!==0&&y===-1) wndData.top = parseInt(wndData.top) - pos2
        if (pos2!==0 || pos1!==0) {wndData.edit=true;actions(wndData)}
    }

    function dragTouchDown(e) {
        e = e || window.event
        posX = parseInt(e.changedTouches[0].clientX/currSize)*currSize
        posY = parseInt(e.changedTouches[0].clientY/currSize)*currSize
        document.ontouchend = closeDragElement
        document.ontouchcancel = closeDragElement
        document.ontouchmove = touchDrag
    }

    function touchDrag(e) {
        let pos1 = 0, pos2 = 0
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - parseInt(e.changedTouches[0].clientX/currSize)*currSize
        pos2 = posY - parseInt(e.changedTouches[0].clientY/currSize)*currSize
        posX = parseInt(e.changedTouches[0].clientX/currSize)*currSize
        posY = parseInt(e.changedTouches[0].clientY/currSize)*currSize
        if(wndData.top-pos2<0) return
        if(wndData.left-pos1<0) return
        // set the element's new position:
        if (pos2!==0) wndData.top=wndData.top-pos2    
        if (pos1!==0) wndData.left=wndData.left-pos1
        if (pos2!==0 || pos1!==0) {wndData.edit=true;actions(wndData)}
    }

    function resizeTouchDown(e,x=1,y=1) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        posX = parseInt(e.changedTouches[0].clientX/currSize)*currSize
        posY = parseInt(e.changedTouches[0].clientY/currSize)*currSize
        document.ontouchend = closeDragElement;
        document.ontouchcancel = closeDragElement
        document.ontouchmove = (e)=>touchResize(e,x,y)
    }

    function touchResize(e,x,y) {
        let pos1 = 0, pos2 = 0
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - parseInt(e.changedTouches[0].clientX/currSize)*currSize
        pos2 = posY - parseInt(e.changedTouches[0].clientY/currSize)*currSize
        if (x===0) pos1=0
        if (y===0) pos2=0
        posX = parseInt(e.changedTouches[0].clientX/currSize)*currSize
        posY = parseInt(e.changedTouches[0].clientY/currSize)*currSize
        if(parseInt(wndData.width) - pos1*x<20) return
        if(parseInt(wndData.height) - pos2*y<20) return
        // set the element's new position:
        if (pos1!==0) wndData.width = parseInt(wndData.width) - pos1*x
        if (pos2!==0) wndData.height = parseInt(wndData.height) - pos2*y
        if (pos1!==0&&x===-1) wndData.left = parseInt(wndData.left) - pos1
        if (pos2!==0&&y===-1) wndData.top = parseInt(wndData.top) - pos2
        if (pos2!==0 || pos1!==0) {wndData.edit=true;actions(wndData)}
    }


    function keyEvent(e) {
        if (document.activeElement.nodeName==='INPUT'){
            if(e.key === 'Enter') document.activeElement.parentNode.parentNode.focus()
            return  
        } 
        if(e.key === 'ArrowRight' && e.shiftKey){
            wndData.width = parseInt(wndData.width)+parseInt(currSize)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowRight' && e.ctrlKey){
            wndData.left=parseInt(wndData.left)+5*parseInt(currSize)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowRight'){
            wndData.left=parseInt(wndData.left)+parseInt(currSize)
            wndData.edit=true
            actions(wndData)
        }else if(e.key === 'ArrowLeft' && e.shiftKey){
            wndData.width = parseInt(wndData.width)-parseInt(currSize)
            wndData.width = Math.max(wndData.width,20)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowLeft' && e.ctrlKey){
            wndData.left=parseInt(wndData.left)-5*parseInt(currSize)
            wndData.left = Math.max(wndData.left,0)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowLeft'){
            wndData.left=parseInt(wndData.left)-parseInt(currSize)
            wndData.left = Math.max(wndData.left,0)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowUp' && e.shiftKey){
            wndData.height=parseInt(wndData.height)-parseInt(currSize)
            wndData.height = Math.max(wndData.height,20)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowUp' && e.ctrlKey){
            wndData.top=parseInt(wndData.top)-5*parseInt(currSize)
            wndData.top = Math.max(wndData.top,0)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowUp'){
            wndData.top=parseInt(wndData.top)-parseInt(currSize)
            wndData.top = Math.max(wndData.top,0)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowDown' && e.shiftKey){
            wndData.height=parseInt(wndData.height)+parseInt(currSize)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowDown' && e.ctrlKey){
            wndData.top=parseInt(wndData.top)+5*parseInt(currSize)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'ArrowDown'){
            wndData.top=parseInt(wndData.top)+parseInt(currSize)
            wndData.edit=true
            actions(wndData)
        } else if(e.key === 'Enter') {
            setActive()
        }
    }

    function keyDnEvent(e) {
        if (document.activeElement.nodeName==='INPUT') return
        if(e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Enter'){
            e.preventDefault()
        }
    }

    const l=parseInt(wndData.left)
    const t=parseInt(wndData.top)
    const w=Math.max(0,parseInt(wndData.width))
    let h=Math.max(0,parseInt(wndData.height))
    if (h===0) h=32
    //let stl={position:'absolute', left:l+'px', top:t+'px', lineHeight:h+'px'}
    let stl={position:'absolute',cursor:'unset',margin:'0',padding:'0', left:l+'px', top:t+'px', height:h+'px'}
    if(w) stl.width=w+'px'
    let img=''
    if (wndData.marked==='1') img=<img style={{width:'20px',height:'20px'}} src={icon+'#dlt'} alt={''} />

    if (wndData.active){
        return(
            <div tabIndex='0' style={{...stl,border:'1px solid'}} onDoubleClick={setActive} onKeyDown={keyDnEvent} onKeyUp={keyEvent}>
            <div onMouseDown={dragMouseDown} onTouchStart={dragTouchDown} 
             className='button fixed print30' style={{lineHeight:h+'px',border:'none',margin:'0',padding:'0',cursor:'unset',width:'100%'}}>{img}
                <input type='text' onChange={e=>setValue(e.target.value)}
                    style={{backgroundColor:'transparent',border:'none',textAlign:'center',color:'inherit',fontSize:'inherit',width:'calc(100% - 48px)',minWidth:'10px'}} value={wndData.name}/>
            </div>
            {/*<div style={{position:'absolute',border:'none',width:'16px',height:'16px',right:'0',bottom:'0',borderBottom:'solid',borderRight:'solid',cursor:'nw-resize'}}></div>*/}
            <div onMouseDown={(e)=>resizeMouseDown(e,1,1)} onTouchStart={(e)=>resizeTouchDown(e,1,1)} style={{borderBottom:'solid',borderRight:'solid',width:'10px',height:'10px',position:'absolute',right:'0',bottom:'0',cursor:'se-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,-1,1)} onTouchStart={(e)=>resizeTouchDown(e,-1,1)} style={{borderBottom:'solid',borderLeft:'solid',width:'10px',height:'10px',position:'absolute',left:'0',bottom:'0',cursor:'sw-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,1,-1)} onTouchStart={(e)=>resizeTouchDown(e,1,-1)} style={{borderTop:'solid',borderRight:'solid',width:'10px',height:'10px',position:'absolute',right:'0',top:'0',cursor:'ne-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,-1,-1)} onTouchStart={(e)=>resizeTouchDown(e,-1,-1)} style={{borderTop:'solid',borderLeft:'solid',width:'10px',height:'10px',position:'absolute',left:'0',top:'0',cursor:'nw-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,0,-1)} onTouchStart={(e)=>resizeTouchDown(e,0,-1)} style={{borderTop:'solid',width:'14px',height:'10px',position:'absolute',left:'calc(50% - 7px)',top:'0',cursor:'n-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,0,1)} onTouchStart={(e)=>resizeTouchDown(e,0,1)} style={{borderBottom:'solid',width:'14px',height:'10px',position:'absolute',left:'calc(50% - 7px)',bottom:'0',cursor:'n-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,1,0)} onTouchStart={(e)=>resizeTouchDown(e,1,0)} style={{borderRight:'solid',width:'10px',height:'14px',position:'absolute',right:'0',top:'calc(50% - 7px)',cursor:'e-resize'}}></div>
            <div onMouseDown={(e)=>resizeMouseDown(e,-1,0)} onTouchStart={(e)=>resizeTouchDown(e,-1,0)} style={{borderLeft:'solid',width:'10px',height:'14px',position:'absolute',left:'0',top:'calc(50% - 7px)',cursor:'e-resize'}}></div>
            </div>
        )
    } else {
        return(
            <div tabIndex='0' className='button fixed print30' style={{...stl,lineHeight:h+'px'}} onDoubleClick={setActive} onKeyUp={(e)=>{if(e.key === 'Enter') {e.preventDefault(); setActive()}}}>{img}{wndData.name}</div>
        )
    }
}

export default CatTablesEdit